import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AgGridTable from "../utilities/AgGridTable";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../utilities/ListPageHeader";
import Select from "react-select";
import {
  Button,
  Select as MuiSelect,
  TextField,
  FormControl,
  MenuItem,
  Stack,
  Switch,
  IconButton,
  Dialog,
  Grid,
} from "@mui/material";
import CustomDatePicker from "../utilities/CustomDatePicker";
// import moment from "moment";
// import ViewProformaInvoiceData from "./ViewProformaInvoiceData";

const initialData = [
  {
    account: "30001 UNIVERSAL TRADING COMPANY",
    debit: "64,500.00",
    credit: "",
    curruncy: "EUR",
    exRate: "1.0000",
    HCurrDR: "64,500.00",
    HCurrCR: "-",
    description: "UT512-UNIVERSAL TRADING COMPANY",
  },
  {
    account: "41100-2-1 DISCOUNT RETAIL SALES NOLTE KITCHEN",
    debit: "21,500.00",
    credit: "",
    curruncy: "EUR",
    exRate: "1.0000",
    HCurrDR: "21,500.00",
    HCurrCR: "-",
    description: "UT512-UNIVERSAL TRADING COMPANY",
  },
  {
    account: "41100-1-1 RETAIL SALES NOLTE KITCHEN",
    debit: "",
    credit: "86,000.00",
    curruncy: "EUR",
    exRate: "1.0000",
    HCurrDR: "-",
    HCurrCR: "86,000.00",
    description: "UT512-UNIVERSAL TRADING COMPANY",
  },
];

const SalesInvoice = () => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.salesInvoice}`;
  const gridRef = useRef();
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState();
  const [rowData, setRowData] = useState(initialData);
  const [gridApi, setGridApi] = useState(null);
  const [snackState, setSnackState] = useState(false);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [showDeleteRow, setShowDeleteRow] = useState(false);
  const [toError, setToError] = useState();
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [rowEvent, setRowEvent] = useState("");
  const navigate = useNavigate();

  const [columnDefs, setColumnDefs] = useState([
    { field: "account" },
    { field: "debit" },
    { field: "credit" },
    { field: "curruncy" },
    { field: "exRate" },
    { field: "HCurrDR" },
    { field: "HCurrCR" },
    { field: "description" },
  ]);

  const onFirstDataRendered = useCallback(() => {
    const allColumnIds = [];
    gridRef.current.columnApi.getColumns().forEach((column) => {
      allColumnIds.push(column?.getId());
    });
    gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
  }, []);

  const onGridReady = useCallback((params) => {
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
  }, []);

  const getSales = async () => {
    try {
      // const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      // let sales = list.data?._embedded?.salesInvoice;
      // setRowData(sales);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    getSales();
  }, []);

  return (
    <>
      <ListPageHeader
        componentName="Sales Invoice"
        // onBtExport={onBtExport}
        // handlePurge={handlePurge}
        pageName="Sales Invoice"
        error={error}
        // deleteDisable={deleteDisable}
        successMsg={successMsg}
        // gridRef={gridRef}
        snackState={snackState}
        showPaginationDropdown={false}
      />

      <Stack direction={"row"} className="mb-10 md:px-16 self-end">
        <div className="flex flex-row">
          <div className="flex flex-row justify-between items-baseline">
            <>
              {/* <FormControl className={"flex"} size="small">
                <label className="pt-12 min-w-fit">Page Size</label>
                <MuiSelect
                  // onChange={onPageSizeChanged}
                  className="ml-5 h-fit min-w-[80px]"
                  // value={selectedSize}
                  id="page-size"
                  // native={true}
                  inputProps={{
                    sx: { padding: "10px" },
                  }}
                >
                  <MenuItem value="10">10</MenuItem>
                  <MenuItem value="20">20</MenuItem>
                  <MenuItem value="50">50</MenuItem>
                  <MenuItem value="100">100</MenuItem>
                </MuiSelect>
              </FormControl> */}

              <Stack className="ml-10">
                <label className="pt-12 min-w-fit">SI number</label>
                <TextField
                  name="siNo"
                  className=" min-w-[100px]"
                  // value={siNo}
                  // onChange={handlechangesiNo}
                  inputProps={{
                    sx: { padding: "10px" },
                  }}
                />
              </Stack>
              <Stack className="ml-10">
                <label className="min-w-fit">Document Date </label>
                <div className="grid">
                  <CustomDatePicker
                    className="w-[150px] h-[20px]"
                    format={"dd-MM-yyyy"}
                    name={"documentDate"}
                    // value={documentDate}
                    // handleChange={handleDocumentDateChange}
                    views={["year", "month", "day"]}
                    componentsProps={{
                      actionBar: { actions: ["clear"] },
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        InputLabelProps={{}}
                        {...params}
                        sx={{
                          backgroundColor: props.viewData && "#8080800f",
                        }}
                      />
                    )}
                  />
                  {/* <p className="text-red">{(fromError && !fromDate) && fromError}</p> */}
                </div>
              </Stack>
            </>
          </div>
        </div>
      </Stack>

      <AgGridTable
        rowData={rowData}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        gridRef={gridRef}
        saveGridStateName={"financing"}
        onFirstDataRendered={onFirstDataRendered}
        enableRowGroup={true}
        hideCheckbox={true}
      />
      {/* <Stack direction={"row"} className="mb-10 md:px-16 self-center">
        <Stack className="ml-10">
          <label className="pt-12 min-w-fit">Total Debits</label>
          <TextField
            name="debits"
            // value={debits}
            // onChange={handlechangedebits}
            inputProps={{
              sx: { padding: "10px" },
            }}
          />
        </Stack>
        <Stack className="ml-10">
          <TextField
            name="company"
            // value={company}
            // onChange={handlechangecompany}
            inputProps={{
              sx: { padding: "10px" },
            }}
          />
        </Stack>
        <Stack className="ml-10">
          <label className="pt-12 min-w-fit">Total Credit</label>
          <TextField
            name="credits"
            // value={credits}
            // onChange={handlechangecredits}
            inputProps={{
                sx: { padding: "10px" },
            }}
            />
            </Stack>
        </Stack> */}
      <Grid container className="flex justify-center">
        <Grid item sx={1} className="flex items-center"><label>{"Total Debits : "}</label></Grid>
        <Grid item sx={2}>
        <TextField
            className="mr-16 my-16"
            name="debits"
            // value={debits}
            // onChange={handlechangedebits}
            inputProps={{
              sx: { padding: "10px" },
            }}
          />
    
        </Grid>
        <Grid item sx={1} className="flex items-center"><label>{"Total Credit : "}</label></Grid>
        <Grid item sx={2}>
        <TextField
            className="mr-16 my-16"
            name="credits"
            // value={credits}
            // onChange={handlechangecredits}
            inputProps={{
                sx: { padding: "10px" },
            }}
            />
        </Grid>
        <Grid item sx={1} className="flex items-center"><label>{"Difference : "}</label></Grid>
        <Grid item sx={2}>
        <TextField
            className="mr-16 my-16"
            name="difference"
            // value={difference}
            // onChange={handlechangedifference}
            inputProps={{
                sx: { padding: "10px" },
            }}
            />
        </Grid>
        <Grid item sx={1} className="flex items-center">
          <label>{"ExRate : "}</label>
        </Grid>
        <Grid item sx={2}>
          <TextField
            className="mr-16 my-16"
            name="difference"
            // value={difference}
            // onChange={handlechangedifference}
            inputProps={{
              sx: { padding: "10px" },
            }}
          />
        </Grid>
      </Grid>
    
    </>
  );
};

export default SalesInvoice;
